import { render } from "./BoxComponent.vue?vue&type=template&id=5127901d&scoped=true"
import script from "./BoxComponent.vue?vue&type=script&lang=js"
export * from "./BoxComponent.vue?vue&type=script&lang=js"

import "./BoxComponent.vue?vue&type=style&index=0&id=5127901d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5127901d"]])

export default __exports__